module.exports = __webpack_public_path__ + "static/media/gym-zoomed-3.ff5dc874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym-zoomed-3.jpg
// module id = 2386
// module chunks = 0